<div class="p-md-5 p-3" id="services">
  <h2 class="text-uppercase">(Our services)</h2>

  <div class="card-container my-4" style="gap: 32px">
    <app-service-card [background]="'/assets/img/service-1.png'" [title]="'Tokenization'"
      [text]="'MAC Tokenizes each Artwork as RWA NFT'" [iconBefore]="'/assets/img/tokenization-icon-1.svg'"
      [iconAfter]="'/assets/img/tokenization-icon-2.svg'"></app-service-card>

    <app-service-card [background]="'/assets/img/service-2.png'" [title]="'Verification & Custody'"
      [text]="'MAC verifies and custodies each tokenized Artwork'" [iconBefore]="'/assets/img/verification-icon-1.svg'"
      [iconAfter]="'/assets/img/verification-icon-2.svg'"></app-service-card>


    <app-service-card [background]="'/assets/img/service-3.png'" [title]="'Delivery'"
      [text]="'MAC coordinates the delivery of each redeemed Artwork, directly to the buyer'"
      [iconBefore]="'/assets/img/delivery-icon-1.svg'"
      [iconAfter]="'/assets/img/delivery-icon-2.svg'"></app-service-card>

    <app-service-card [background]="'/assets/img/service-4.png'" [title]="'Promotion'"
      [text]="'MAC organizes gatherings and special events for passionate collectors'"
      [iconBefore]="'/assets/img/promotion-icon-1.svg'"
      [iconAfter]="'/assets/img/promotion-icon-2.svg'"></app-service-card>
  </div>
</div>